// extracted by mini-css-extract-plugin
export default {"ButtonReject":"RejectMappingButton_ButtonReject__BzvRQ","ButtonGroup":"RejectMappingButton_ButtonGroup__TvlhM"};